<template>
  <div>
    <div class="artwork-text-editor">
      <quill-editor
        v-model="content"
        :options="editorOptions"
        @change="onEditorChange"
      />
      <div class="artwork-text-editor__actions">
        <v-btn @click="copy2c" small flat title="Copy text" aria-label="Copy text">
          <v-icon small left>file_copy</v-icon>Copy
        </v-btn>
        <v-btn @click="download_text" small flat title="Download text" aria-label="Download text">
          <v-icon small left>download</v-icon>Download
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  components: { quillEditor },

  methods: {
    onEditorChange({ html }) {
      this.$emit('input', html)
    },

    copy2c() {
      const t = this.content
      const listener = function (ev) {
        ev.preventDefault()
        ev.clipboardData.setData('text/html', t)
        ev.clipboardData.setData('text/plain', t)
      }
      document.addEventListener('copy', listener)
      document.execCommand('copy')
      document.removeEventListener('copy', listener)
    },

    download_text() {
      let textTitle = ''
      if (this.text) {
        textTitle = this.text.title
      }
      this.exportHTML(this.content, textTitle)
    }
  },

  props: ['value', 'text', 'artwork'],

  data() {
    return {
      content: this.value,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ]
        },
        placeholder: 'Start typing...',
        theme: 'snow'
      }
    }
  },

  watch: {
    value(newVal) {
      if (this.content !== newVal) {
        this.content = newVal
      }
    }
  }
}
</script>

<style>
.artwork-text-editor {
    width: 100%;
    margin: 0;
    overflow: hidden;
    border: 1px solid #ded9e1;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(57, 41, 57, 0.08);
}
.artwork-text-editor .ql-toolbar.ql-snow {
    border: 0;
    border-bottom: 1px solid #ebe7ee;
    background: #faf8fb;
    padding: 10px 14px;
}
.artwork-text-editor .ql-toolbar .ql-stroke {
    stroke: #392939;
}
.artwork-text-editor .ql-toolbar .ql-fill {
    fill: #392939;
}
.artwork-text-editor .ql-toolbar button:hover,
  .artwork-text-editor .ql-toolbar button.ql-active {
    border-radius: 6px;
    background: #eee7f0;
}
.artwork-text-editor .ql-container.ql-snow {
    border: 0;
    min-height: 280px;
    font-size: 17px;
}
.artwork-text-editor .ql-editor {
    min-height: 280px;
    padding: 20px 22px;
    color: #29252b;
    line-height: 1.65;
}
.artwork-text-editor .ql-editor.ql-blank::before {
    color: #9a919d;
    font-style: normal;
    left: 22px;
}
.artwork-text-editor .ql-editor p {
    margin-bottom: 0;
}
.artwork-text-editor__actions {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    padding: 6px 10px;
    border-top: 1px solid #ebe7ee;
    background: #faf8fb;
}
.artwork-text-editor__actions .v-btn {
    color: #392939;
    text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/TextEditor.vue